import { PropsWithChildren } from 'react';
import { Flex, Field } from '@chakra-ui/react';
import { AnyBlock, BlockType } from '@/lib/types';

export interface BaseInputBlockProps<T = AnyBlock> {
  block: T;
}

export default function BaseInputBlock({
  block,
  children,
}: PropsWithChildren<BaseInputBlockProps>) {
  return (
    <Field.Root>
      <Flex width="full" gap="4" justify="space-between">
        {![BlockType.Checkbox, BlockType.SectionTitle].includes(block.field_type) && (
          <Field.Label>{block.field_name}</Field.Label>
        )}
      </Flex>
      {children}
    </Field.Root>
  );
}
